import React, { Component } from 'react';
import { decryptCookie } from '../helpers';
import Cookies from 'universal-cookie';
const cookies = new Cookies();
import { appBasePath } from '../constants/staticData';

export default class Dashboard extends Component {
  constructor(props, context) {
    super(props, context);
  }
  componentWillMount() {
    this.props.actions.fetchCurrentUserInfo(this.props.router);
    const signedUserDataCookie = cookies.get('carauth');
    if (localStorage && localStorage.businessAuthData) {
      const authData = JSON.parse(localStorage.businessAuthData);
      if (!authData.phone) {
        this.props.router.push(`${appBasePath}/send-otp`);
      } else if (!authData.phoneVerified) {
        this.props.router.push(`${appBasePath}/verify-otp`);
      }
    } else if (!signedUserDataCookie) {
      this.props.router.push('/');
    }
  }
  componentWillReceiveProps() {
    if (localStorage && localStorage.businessAuthData) {
      const authData = JSON.parse(localStorage.businessAuthData);
      if (!authData.phone) {
        this.props.router.push(`${appBasePath}/send-otp`);
      } else if (!authData.phoneVerified) {
        this.props.router.push(`${appBasePath}/verify-otp`);
      }
    } else {
      const that = this;
      setTimeout(
        () => {
          that.props.router.push(`${appBasePath}/`);
        },
        800
      );
    }
  }

  render() {
    return (
      <div>
        <h1>UI not available</h1>
        <a style={{ cursor: 'pointer' }} onClick={() => this.props.actions.logout(this.props.router)}>Logout</a>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Dashboard.jsx